<template>
    <div>
        <h1>{{ nombreUsuario }}</h1>
         <v-btn
        depressed
        color="primary"
        @click="cambiarPassword">
        Cambiar contraseña
        </v-btn>
        <cartas-personalizadas :cartas="datosVisitas" />
        <cartas-personalizadas :cartas="datosPagos" />
    </div>
</template>
<script>
export default {
    name: "MiPerfil",

    data: () => ({
        nombreUsuario: localStorage.getItem('nombreUsuario') || '—',
        rolUsuario:    localStorage.getItem('rolUsuario')    || '—',
        tenant:        localStorage.getItem('db_tenant')     || '—',
    }),

    methods: {
        cambiarPassword () {
            this.$router.push({ name: 'CambiarPassword' })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/MiPerfil.vue